import { Box, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Header } from "./global/Header";
import Sidebar from "./global/Sidebar";
import Topbar from "./global/Topbar";
import { useState } from "react";
import SidebarMobile from "./global/SidebarMobile";
import BASE_URL from "../NetworkConfig/ApiConfig";
import { QrCode2Rounded, QrCodeScanner, ScannerOutlined } from "@mui/icons-material";

export const Admin = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [AdminState, setAdminState] = useState(null);
  // const [loading, setloading] = useState(true);
  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')
  const [error, seterror] = useState("Loading....");
  const [showTab, setShowTab] = useState(false)
  const FetchAdminDetails = async () => {
    // setloading(true);

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${BASE_URL}/admin/getadmindetails/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      });
      const data = await response.json();

      if (data.success === true) {
        setAdminState(data.response);
        localStorage.setItem("profile", JSON.stringify(data.response))
        // setloading(false);
        return;
      }
      if (data.success === false) {
        seterror(data.response);
        localStorage.clear()
        navigate("/", { replace: true });
        return;
      }
    } catch (error) {
      localStorage.clear()
      navigate("/", { replace: true });
      return;
    }

  };

  useEffect(() => {
    if (!token) {
      navigate("/", { replace: true });
    } else {
      FetchAdminDetails();
    }
  }, []);
  if (!AdminState) {
    return <Box>{error}</Box>;
  }
  return (
    <div className="app" >
      {

        !isMobileScreen && !isTabScreen && (
          <Sidebar data={AdminState} />
        )
      }

      {
        (isMobileScreen || isTabScreen) && showTab && (
          <SidebarMobile data={AdminState} onClick={() => {
            setShowTab(false)
          }} mobile={true} />
        )
      }
      <main className="content" style={{ marginLeft: (!isMobileScreen && !isTabScreen) ? "300px" : "0px", paddingTop: "85px" }}>
        <Topbar data={AdminState} onClick={() => {
          setShowTab(!showTab)
        }} />
        <Outlet />
      </main>


      {/* <Box component={Link}
        to={{
          pathname: "/admin/scan-and-validate",
          state: { fromDashboard: true },
        }}
        sx={{
          position: 'fixed', zIndex: 10, right: 25, bottom: 25, alignItems: 'center', justifyContent: 'center',
          display: 'flex', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', cursor: 'pointer',
          borderRadius: 100, background: "#272727", width: "65px", height: "65px"
        }}>
        <QrCodeScanner style={{color: "white", fontSize: "32px"}} />
      </Box> */}

    </div>
  );
};